export default __webpack_public_path__ + "content/fda_approved_oncology_therapies.xlsx";